import { render } from "./check.vue?vue&type=template&id=9ef901e4"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/check.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9ef901e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9ef901e4', __exports__)) {
    api.reload('9ef901e4', __exports__)
  }
  
  module.hot.accept("./check.vue?vue&type=template&id=9ef901e4", () => {
    api.rerender('9ef901e4', render)
  })

}


export default __exports__